import { Box, IconButton } from '@mui/material';
import * as theme from '../theme';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

export default function PDFDisplay({ url, description }) {

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: url !== '' ? 'flex-start' : 'center',
        justifyContent: 'space-between',
        backgroundColor: theme.Colors.GrayVeryLight,
        border: `1px solid ${theme.Colors.Purple}`,
        borderRadius: '8px',
        padding: '24px',
        marginBottom: '10px',
        color: theme.Colors.GrayDark,
      }}
      aria-live="assertive"
    >
      {url === '' && 
        <IconButton
          size="large"
          aria-label="Download PDF"
          onClick={() => null}
          sx={{ color: theme.Colors.Purple, marginRight: 4, marginLeft: 2 }}
        >
          <ReportProblemIcon fontSize="large" />
        </IconButton>
      }
      {url !== '' &&
        <IconButton
          size="large"
          aria-label="Download PDF"
          onClick={() => window.open(url, '_blank')}
          sx={{ color: theme.Colors.Purple, marginRight: 4, marginLeft: 2 }}
        >
          <PictureAsPdfIcon fontSize="large" />
        </IconButton>
      }
      <span style={{ flex: 1, lineHeight: 1.6, paddingRight: 20 }}>{url !== '' ? description : 'Error: Cannot find PDF file.'}</span>
    </Box>
  );
}